(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3599],{

/***/ 70134:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candylock/v2",
      function () {
        return __webpack_require__(45609);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39112);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 16px;\n  box-shadow: ",
        ";\n  color: ",
        ";\n  display: block;\n  font-size: 16px;\n  height: ",
        ";\n  outline: 0;\n  padding: 0 16px;\n  width: 100%;\n  border: 1px solid ",
        ";\n\n  &::placeholder {\n    color: ",
        ";\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    box-shadow: none;\n    color: ",
        ";\n    cursor: not-allowed;\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Priority: Warning --> Success
 */ var getBoxShadow = function getBoxShadow(param) {
    var _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? false : _isSuccess, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning, theme = param.theme;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.inset;
};
var getHeight = function getHeight(param) {
    var _scale = param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD : _scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.LG */ .Q.LG:
            return "48px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "40px";
    }
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-c22a9310-0"
}).withConfig({
    componentId: "sc-39f22014-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, getBoxShadow, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, getHeight, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme, isWarning = param.isWarning, isSuccess = param.isSuccess;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.focus;
});
Input.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD,
    isSuccess: false,
    isWarning: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 39112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};


/***/ }),

/***/ 45609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ candylock_v2; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/config/constants/supportChains.ts
var supportChains = __webpack_require__(47747);
// EXTERNAL MODULE: ./src/views/CandyLock/index.tsx + 1 modules
var CandyLock = __webpack_require__(72083);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(38144);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(23774);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 8 modules
var src = __webpack_require__(51071);
// EXTERNAL MODULE: ./src/views/CandyLock/components/LockCard/LockCardHeader.tsx + 1 modules
var LockCardHeader = __webpack_require__(12670);
// EXTERNAL MODULE: ./src/views/CandyLock/hooks/helpers.ts
var helpers = __webpack_require__(26432);
// EXTERNAL MODULE: ./src/views/CandyLock/components/LockTimer.tsx
var LockTimer = __webpack_require__(60737);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(95963);
// EXTERNAL MODULE: ./src/utils/getNftImageUrl.ts
var getNftImageUrl = __webpack_require__(62421);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/views/CandyLock/hooks/v2/useLockReward.ts
var useLockReward = __webpack_require__(68657);
// EXTERNAL MODULE: ./src/views/CandyLock/components/Nft/NftItem.tsx
var NftItem = __webpack_require__(87425);
// EXTERNAL MODULE: ./src/views/CandyLock/components/LockCard/v2/EarlyClaimFee.tsx
var EarlyClaimFee = __webpack_require__(3558);
// EXTERNAL MODULE: ./src/views/CandyLock/components/LockCard/v2/AvailableReward.tsx
var AvailableReward = __webpack_require__(52891);
// EXTERNAL MODULE: ./src/views/CandyLock/components/LockCard/v2/EarlyUnlockFee.tsx
var EarlyUnlockFee = __webpack_require__(89267);
;// CONCATENATED MODULE: ./src/views/CandyLock/components/LockCard/v2/LockCardDetails.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 12px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  color: ",
        ";\n  display: flex;\n  margin-bottom: 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // color: ",
        ";\n  font-size: 16px;\n  font-weight: bold;\n  display: flex;\n  border: 1px solid ",
        ";\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 2px;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin-left: ",
        ";\n  flex: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  gap: 8px;\n  overflow-x: auto;\n  overflow-y: hidden;\n\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}














var StyledLockCardDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1b013d0-0"
})(_templateObject());
var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1b013d0-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
});
var Notion = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1b013d0-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var Display = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-c1b013d0-3"
})(_templateObject3(), function(param) {
    var subHeader = param.subHeader;
    return subHeader ? "13px" : "15px";
}, function(param) {
    var subHeader = param.subHeader;
    return subHeader ? "8px" : "0px";
});
var NftRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c1b013d0-4"
})(_templateObject4());
var LockCardDetails = function(param) {
    var data = param.data, config = param.config, epochTime = param.epochTime;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var candyToken = src/* cronosTokens.candy */.R7.candy;
    var id = data.id, lockAt = data.lockAt, duration = data.duration, lastRewardAt = data.lastRewardAt, tokenAmount = data.tokenAmount, listed = data.listed, listPrice = data.listPrice, nftIds = data.nftIds;
    var penaltyStart = config.penaltyStart, penaltyDelta = config.penaltyDelta, aprRates = config.aprRates, boostRates = config.boostRates;
    var ref = (0,useLockReward/* default */.Z)(id), reward = ref.reward, penaltyPercent = ref.penaltyPercent, penaltyAppliedReward = ref.penaltyAppliedReward;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLockCardDetails, {
            children: [
                listed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notion, {
                    children: t("Listed for the sale in %price% CANDY", {
                        price: (0,formatBalance/* getBalanceNumber */.mW)(listPrice, candyToken.decimals).toLocaleString()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("Lock Start Date")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "".concat(new Date(lockAt * 1000).toLocaleString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                timeZone: "UTC"
                            }), " (UTC)")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("Lock End Date")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "".concat(new Date((lockAt + duration) * 1000).toLocaleString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                timeZone: "UTC"
                            }), " (UTC)")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("Lock Amount")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            children: [
                                (0,formatBalance/* getBalanceNumber */.mW)(tokenAmount, candyToken.decimals).toLocaleString("en-US", {
                                    maximumFractionDigits: 3
                                }),
                                " ",
                                candyToken.symbol
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("Boosting Nfts")
                        }),
                        nftIds.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "No NFTs Locked"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                }),
                nftIds.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NftRow, {
                    children: nftIds.map(function(nft) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NftItem/* default */.Z, {
                            id: nft,
                            image: (0,getNftImageUrl/* default */.Z)(nft)
                        }, "Boost NFT item - ".concat(nft));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("APR")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            children: [
                                (0,helpers/* getLockApr */.he)(aprRates, boostRates, duration, nftIds),
                                " %"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EarlyClaimFee/* default */.Z, {
                        penaltyStart: penaltyStart,
                        penaltyDelta: penaltyDelta,
                        penaltyPercent: penaltyPercent
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Display, {
                            children: t("Available Reward")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableReward/* default */.Z, {
                            lastRewardAt: lastRewardAt,
                            penaltyAppliedReward: penaltyAppliedReward,
                            penaltyPercent: penaltyPercent,
                            reward: reward
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EarlyUnlockFee/* default */.Z, {
                        duration: duration,
                        epochTime: epochTime,
                        lockAt: lockAt
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v2_LockCardDetails = (LockCardDetails);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 14 modules
var Toast = __webpack_require__(71999);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx + 1 modules
var useCatchTxError = __webpack_require__(57164);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./src/views/CandyLock/hooks/v2/useLockToken.ts
var useLockToken = __webpack_require__(26762);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(5324);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
;// CONCATENATED MODULE: ./src/views/CandyLock/components/LockCard/v2/LockTransferModal.tsx



function LockTransferModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-top: 6px;\n\n  svg {\n    width: 24px;\n  }\n"
    ]);
    LockTransferModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LockTransferModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: none;\n  padding: 0 8px;\n  height: 42px;\n  width: 100%;\n  font-size: 14px;\n  z-index: 1;\n  border-radius: 6px;\n\n  ",
        " {\n    font-size: 16px;\n    width: 450px;\n  }\n"
    ]);
    LockTransferModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LockTransferModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 500;\n"
    ]);
    LockTransferModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9908a855-0"
})(LockTransferModal_templateObject());
var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-9908a855-1"
})(LockTransferModal_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var LockTransferModal_Display = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-9908a855-2"
})(LockTransferModal_templateObject2());
var LockTransferModal = function(param) {
    var id = param.id, onDismiss = param.onDismiss;
    var ref = (0,react.useState)(""), value = ref[0], setValue = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref1 = (0,useToast/* default */.Z)(), toastSuccess = ref1.toastSuccess, toastError = ref1.toastError;
    var ref2 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref2.fetchWithCatchTxError, pendingTx = ref2.loading;
    var onTransfer = (0,useLockToken/* default */.Z)().onTransfer;
    var handleChange = (0,react.useCallback)(function(e) {
        setValue(e.currentTarget.value.trim());
    }, []);
    var handleTransfer = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onTransfer(id, value);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Transferred"), "!"), t("Your lock has been transferred to new owner"));
                            onDismiss();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleTransfer() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        title: "Transfer Lock",
        onDismiss: onDismiss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockTransferModal_Display, {
                        children: t("New Owner")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                        pattern: "^(0x)?[0-9a-fA-F]{40}$",
                        disabled: pendingTx,
                        onChange: handleChange,
                        placeholder: "0x0000000000000000000000000000000000000000",
                        value: value
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                mt: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        variant: "secondary",
                        onClick: onDismiss,
                        mr: "8px",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        disabled: pendingTx || !value,
                        onClick: handleTransfer,
                        children: "Transfer"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v2_LockTransferModal = (LockTransferModal);

// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(44431);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
;// CONCATENATED MODULE: ./src/views/CandyLock/components/LockCard/v2/LockListModal.tsx



function LockListModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-top: 6px;\n\n  svg {\n    width: 24px;\n  }\n"
    ]);
    LockListModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LockListModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: none;\n  padding: 0 8px;\n  height: 42px;\n  width: 100%;\n  font-size: 14px;\n  z-index: 1;\n  border-radius: 6px;\n\n  ",
        " {\n    font-size: 16px;\n    width: 450px;\n  }\n"
    ]);
    LockListModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LockListModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 500;\n"
    ]);
    LockListModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var LockListModal_InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fae591ef-0"
})(LockListModal_templateObject());
var LockListModal_StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-fae591ef-1"
})(LockListModal_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var LockListModal_Display = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-fae591ef-2"
})(LockListModal_templateObject2());
var LockListModal = function(param) {
    var id = param.id, onDismiss = param.onDismiss;
    var ref = (0,react.useState)(0), value = ref[0], setValue = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref1 = (0,useToast/* default */.Z)(), toastSuccess = ref1.toastSuccess, toastError = ref1.toastError;
    var ref2 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref2.fetchWithCatchTxError, pendingTx = ref2.loading;
    var candyToken = src/* cronosTokens.candy */.R7.candy;
    var onList = (0,useLockToken/* default */.Z)().onList;
    var handleChange = (0,react.useCallback)(function(e) {
        if (e.currentTarget.validity.valid) {
            var currentValue = Number(e.currentTarget.value.replace(/,/g, "."));
            setValue(currentValue);
        }
    }, []);
    var handleList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onList(id, (0,formatBalance/* getDecimalAmount */.Qe)(new (bignumber_default())(value), candyToken.decimals).toFixed());
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Listed"), "!"), t("Your lock has been listed for the sale"));
                            onDismiss();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleList() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        title: "List Lock",
        onDismiss: onDismiss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LockListModal_InputWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockListModal_Display, {
                        children: t("Listing Price in CANDY")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LockListModal_StyledInput, {
                        pattern: "^[0-9]*",
                        inputMode: "decimal",
                        step: "any",
                        min: "0",
                        disabled: pendingTx,
                        onChange: handleChange,
                        placeholder: "0",
                        value: value > 0 ? value : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                mt: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        variant: "secondary",
                        onClick: onDismiss,
                        mr: "8px",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: "100%",
                        disabled: pendingTx || value <= 0,
                        onClick: handleList,
                        children: "List"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v2_LockListModal = (LockListModal);

;// CONCATENATED MODULE: ./src/views/CandyLock/components/LockCard/v2/LockCardAction.tsx




function LockCardAction_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  color: ",
        ";\n  display: flex;\n  margin-bottom: 4px;\n"
    ]);
    LockCardAction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var LockCardAction_Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4a575ac-0"
})(LockCardAction_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
});
var LockCardAction = function(param) {
    var data = param.data;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), status = ref[0], setStatus = ref[1];
    var id = data.id, listed = data.listed;
    var reward = (0,useLockReward/* default */.Z)(id).reward;
    var ref1 = (0,useLockToken/* default */.Z)(), onClaim = ref1.onClaim, onDelist = ref1.onDelist, onUnlock = ref1.onUnlock;
    var toastSuccess = (0,useToast/* default */.Z)().toastSuccess;
    var ref2 = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = ref2.fetchWithCatchTxError, pendingTx = ref2.loading;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(v2_LockTransferModal, {
        id: id
    })), 1), onPresentTransferModal = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(v2_LockListModal, {
        id: id
    })), 1), onPresentListModal = ref4[0];
    var toggleStatus = function() {
        setStatus(!status);
    };
    var handleDelist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchWithCatchTxError(function() {
                            return onDelist(id);
                        });
                    case 2:
                        receipt = _ctx.sent;
                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                            toastSuccess("".concat(t("Delisted"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                txHash: receipt.transactionHash,
                                children: t("Your lock has been delisted")
                            }));
                            toggleStatus();
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDelist() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LockCardAction_Item, {
                style: {
                    gap: "8px",
                    marginTop: "16px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: pendingTx || reward.isEqualTo(bigNumber/* BIG_ZERO */.HW),
                        style: {
                            flex: "1"
                        },
                        onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            var receipt;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return fetchWithCatchTxError(function() {
                                            return onClaim(id);
                                        });
                                    case 2:
                                        receipt = _ctx.sent;
                                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                                            toastSuccess("".concat(t("Claimed"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                                txHash: receipt.transactionHash,
                                                children: t("Claimed tokens have been sent to your wallet!")
                                            }));
                                            toggleStatus();
                                        }
                                    case 4:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: "Claim Reward"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: pendingTx,
                        style: {
                            flex: "1"
                        },
                        onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            var receipt;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return fetchWithCatchTxError(function() {
                                            return onUnlock(id);
                                        });
                                    case 2:
                                        receipt = _ctx.sent;
                                        if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                                            toastSuccess("".concat(t("Unlocked"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                                                txHash: receipt.transactionHash,
                                                children: t("Unlocked tokens have been sent to your wallet!")
                                            }));
                                            toggleStatus();
                                        }
                                    case 4:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: "Unlock"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LockCardAction_Item, {
                style: {
                    gap: "8px",
                    marginTop: "16px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: pendingTx,
                        style: {
                            flex: "1"
                        },
                        onClick: onPresentTransferModal,
                        children: "Transfer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: pendingTx,
                        style: {
                            flex: "1"
                        },
                        onClick: function() {
                            if (listed) handleDelist();
                            else onPresentListModal();
                        },
                        children: listed ? t("Delist") : t("List")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v2_LockCardAction = (LockCardAction);

;// CONCATENATED MODULE: ./src/views/CandyLock/components/LockCard/v2/index.tsx



function v2_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 437px;\n  width: 100%;\n"
    ]);
    v2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var StyledLockCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-63f50a78-0"
})(v2_templateObject());
var LockV2Card = function(param) {
    var data = param.data, config = param.config, onUnlocked = param.onUnlocked;
    var candyToken = src/* cronosTokens.candy */.R7.candy;
    var duration = data.duration, lockAt = data.lockAt;
    var ref = (0,react.useState)({
        status: null,
        currentTime: Math.floor(Date.now() / 1000)
    }), state = ref[0], setState = ref[1];
    (0,react.useEffect)(function() {
        var interval = setInterval((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var currentTime, status;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        currentTime = Math.floor(Date.now() / 1000);
                        status = (0,helpers/* getStatus */.lR)(currentTime, lockAt, duration);
                        setState({
                            status: status,
                            currentTime: currentTime
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })), 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        lockAt,
        duration
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLockCard, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
            style: {
                padding: "24px 16px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LockCardHeader/* default */.Z, {
                    name: candyToken.name,
                    address: candyToken.address
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LockTimer/* default */.Z, {
                    currentTime: state.currentTime,
                    duration: duration,
                    lockAt: lockAt,
                    unlocked: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_LockCardDetails, {
                    config: config,
                    data: data,
                    epochTime: state.currentTime
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_LockCardAction, {
                    data: data
                })
            ]
        })
    });
};
/* harmony default export */ var v2 = (LockV2Card);

// EXTERNAL MODULE: ./src/views/CandyLock/components/LockCards.tsx
var LockCards = __webpack_require__(90081);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 2 modules
var wagmi_src = __webpack_require__(2216);
// EXTERNAL MODULE: ./src/config/abi/candyLockV2.json
var candyLockV2 = __webpack_require__(6023);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(96273);
// EXTERNAL MODULE: ./src/utils/wagmi.ts + 13 modules
var wagmi = __webpack_require__(69330);
;// CONCATENATED MODULE: ./src/views/CandyLock/hooks/v2/useLockList.ts









// Retrieve Lock list
var useLockList = function(dependency) {
    var ref = (0,wagmi_src/* useWeb3React */.G)(), account = ref.account, chainId = ref.chainId;
    var ref1 = (0,react.useState)([]), lockList = ref1[0], setLockList = ref1[1];
    var candyLockV2Address = (0,addressHelpers/* getCandyLockV2Address */.O$)(chainId);
    (0,react.useEffect)(function() {
        var fetchLockList = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var client, countResult, lockCount, listResult;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            client = (0,wagmi/* publicClient */.z2)({
                                chainId: chainId
                            });
                            _ctx.next = 3;
                            return client.readContract({
                                abi: candyLockV2,
                                address: candyLockV2Address,
                                functionName: "userAllLockCount",
                                args: [
                                    account
                                ]
                            });
                        case 3:
                            countResult = _ctx.sent;
                            lockCount = Number(countResult);
                            _ctx.next = 7;
                            return client.readContract({
                                abi: candyLockV2,
                                address: candyLockV2Address,
                                functionName: "userAllLocks",
                                args: [
                                    account,
                                    0,
                                    lockCount
                                ]
                            });
                        case 7:
                            listResult = _ctx.sent;
                            // @ts-ignore
                            setLockList(listResult.map(function(data) {
                                return {
                                    id: Number(data.id),
                                    owner: data.owner,
                                    tokenAmount: new (bignumber_default())(data.tokenAmount.toString()),
                                    lockAt: Number(data.lockAt),
                                    duration: Number(data.duration),
                                    lastRewardAt: Number(data.lastRewardAt),
                                    listPrice: new (bignumber_default())(data.listPrice.toString()),
                                    listed: new (bignumber_default())(data.listPrice.toString()).isGreaterThan(bigNumber/* BIG_ZERO */.HW),
                                    nftIds: data.nftIds,
                                    nftRarities: data.nftRarities
                                };
                            }));
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchLockList() {
                return _ref.apply(this, arguments);
            };
        }();
        if (account) fetchLockList();
        else setLockList([]);
    }, [
        candyLockV2Address,
        account,
        chainId,
        dependency
    ]);
    return {
        lockList: lockList
    };
};
/* harmony default export */ var v2_useLockList = (useLockList);

// EXTERNAL MODULE: ./src/views/CandyLock/hooks/v2/useLockConfig.ts
var useLockConfig = __webpack_require__(38473);
;// CONCATENATED MODULE: ./src/views/CandyLock/AllV2Locks.tsx







var AllV2Locks = function() {
    var ref = (0,react.useState)(false), status = ref[0], setStatus = ref[1];
    var lockList = v2_useLockList(status).lockList;
    var lockConfig = (0,useLockConfig/* default */.Z)();
    var toggleStatus = function() {
        setStatus(!status);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LockCards/* default */.Z, {
        isSingle: lockList.length === 0,
        children: lockList.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            justifyContent: "center",
            mt: "24px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "lg",
                children: "You do not have Lock."
            })
        }) : lockList.map(function(lockData) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(v2, {
                config: lockConfig,
                data: lockData,
                onUnlocked: toggleStatus
            }, lockData.id);
        })
    });
};
/* harmony default export */ var CandyLock_AllV2Locks = (AllV2Locks);

;// CONCATENATED MODULE: ./src/pages/candylock/v2/index.tsx




var CandyLockPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CandyLock_AllV2Locks, {});
};
CandyLockPage.Layout = CandyLock/* CandyLockV2Layout */.Jw;
CandyLockPage.chains = supportChains/* SUPPORT_LOCK */.sT;
/* harmony default export */ var candylock_v2 = (CandyLockPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6309,9049,4886,9774,2888,179], function() { return __webpack_exec__(70134); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);